<template>
  <div class="laboratory-reference-range-input-form">
    <validation-observer
      class="validation-observer"
      tag="div"
      v-slot="{ errors }"
    >
      <div class="input-wrapper">
        <validation-provider
          class="validation-provider"
          tag="div"
          vid="low"
          :rules="lowRules"
        >
          <base-text-box
            data-test="base-text-box low"
            :maxlength="10"
            :styles="makeLowInputStyle(errors)"
            :value="laboratoryReferenceRange.low"
            @blur="focus('low')"
            @input="inputValue(laboratoryReferenceRange.id, 'low', $event)"
          />
        </validation-provider>
        <div class="en-dash">–</div>
        <validation-provider
          class="validation-provider"
          tag="div"
          vid="high"
          :rules="highRules"
        >
          <base-text-box
            data-test="base-text-box high"
            :maxlength="10"
            :styles="makeHighInputStyle(errors)"
            :value="laboratoryReferenceRange.high"
            @blur="focus('high')"
            @input="inputValue(laboratoryReferenceRange.id, 'high', $event)"
          />
        </validation-provider>
      </div>
      <div class="error" data-test="error range">
        <span>{{ toErrorText(errors) }}</span>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import BaseTextBox from '@/components/parts/atoms/BaseTextBox'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'LaboratoryReferenceRangeInputForm',

  components: {
    ValidationObserver,
    ValidationProvider,
    BaseTextBox
  },

  props: {
    laboratoryReferenceRange: { type: Object, default: () => {} }
  },

  data() {
    return {
      focusedVId: '',
      floatErrorMessage: '0以上の数値を入力してください'
    }
  },

  computed: {
    highRules() {
      const message = this.floatErrorMessage
      const low = this.laboratoryReferenceRange.low
      return this.isFloat(low)
        ? { floatRule: { message }, greaterThan: { minValue: low } }
        : { floatRule: { message } }
    },
    lowRules() {
      const message = this.floatErrorMessage
      const high = this.laboratoryReferenceRange.high
      return this.isFloat(high)
        ? { floatRule: { message }, lessThan: { maxValue: high } }
        : { floatRule: { message } }
    }
  },

  methods: {
    focus(vid) {
      this.focusedVId = vid
    },
    inputValue(laboratoryReferenceRangeId, key, value) {
      this.focusedVId = key
      this.$emit('input-value', {
        laboratoryReferenceRangeId,
        key,
        value
      })
    },
    isFloat(value) {
      const regex = /^([1-9]\d*|0)(\.\d+)?$/
      const isFloat = regex.test(value)
      return isFloat
    },
    makeHighInputStyle(errors) {
      const baseStyle = { textAlign: 'right', width: '85px' }
      return this.showHighError(errors)
        ? { ...baseStyle, borderColor: 'red' }
        : baseStyle
    },
    makeLowInputStyle(errors) {
      const baseStyle = { textAlign: 'right', width: '85px' }
      return this.showLowError(errors)
        ? { ...baseStyle, borderColor: 'red' }
        : baseStyle
    },
    showHighError(errors) {
      const focusedVId = this.focusedVId
      const { high } = errors
      const hasHighError = high?.length > 0
      return hasHighError && focusedVId === 'high'
    },
    showLowError(errors) {
      const focusedVId = this.focusedVId
      const { low } = errors
      const hasLowError = low?.length > 0
      return hasLowError && focusedVId === 'low'
    },
    toErrorText(errors) {
      const focusedVId = this.focusedVId
      const { low, high } = errors
      const hasLowError = low?.length > 0
      const hasHighError = high?.length > 0
      let text = ''
      if (hasLowError && focusedVId === 'low') {
        text = low[0]
      } else if (hasHighError && focusedVId === 'high') {
        text = high[0]
      } else if (hasLowError) {
        text = low[0]
        this.focusedVId = 'low'
      } else if (hasHighError) {
        text = high[0]
        this.focusedVId = 'high'
      }
      return text
    }
  }
}
</script>

<style lang="scss" scoped>
.laboratory-reference-range-input-form {
  > .validation-observer {
    position: relative;
    margin-left: 20px;
    > .input-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0 10px;
    }
    > .error {
      position: absolute;
      z-index: 10;
      color: #{$tomato};
      font-size: 11px;
      text-align: left;
      white-space: nowrap;
      background-color: #{$white};
    }
  }
}
</style>
